<template>
  <!-- modal cadastro -->
  <b-modal id="modal-cadastrar" dialog-class="modal-conta" size="lg" hide-footer :no-enforce-focus="true">
    <template slot="modal-header">
      <h5 class="modal-title" v-if="!isVisualizacao">Cadastrar notificação</h5>
      <h5 class="modal-title" v-else>Visualizar notificação</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-cadastrar')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>
    <form>
      <fieldset :disabled="isVisualizacao">
      <div class="row">
        <div class="col-12">
          <form-group id="tituloNotif" label="Título *" :text="{ required: 'Obrigatório informar o título' }" :field="$v.notificacao.notificacao">
            <input type="text" class="form-control" id="titulo" v-model="notificacao.notificacao"/>
          </form-group>
        </div>
        <div class="col-12 col-md-4">
           <form-group id="OcorrenciaQtd"  label="Número de ocorrências *" :field="$v.notificacao.ocorrencia_quantidade">
           <input type="number" min="1" max="100" class="form-control" id="ocorrQtd" v-model="notificacao.ocorrencia_quantidade"/>
          </form-group>
        </div>
        <div class="col-12 col-md-4" v-if="notificacao.ocorrencia_quantidade > 1">
           <form-group id="OcorrenciaDias"  label="Intervalo de recorrência *" :field="$v.notificacao.ocorrencia_dias_intervalo">
           <input type="number" min="1" max="100" class="form-control" id="ocorrDias" v-model="notificacao.ocorrencia_dias_intervalo"/>
          </form-group>
        </div>
        <div class="col-12 col-md-12" v-if="notificacao.ocorrencia_quantidade == 1">
        </div>
        <div :class="isVisualizacao ? 'col-12 col-md-6': 'col-12 col-md-6'">
          <form-group id="TipoNotif" label="Qual é o tipo de notificação? *" :text="{ required: 'Obrigatório informar o tipo de notificação' }" :field="$v.notificacao.tipo_notificacao_id">
            <input type="text" class="form-control" id="tipo" v-model="descricaoTipo" v-if="isVisualizacao"/>
            <select class="form-control" v-model="notificacao.tipo_notificacao_id" v-else>
              <option v-for="tipo in tipos" :value="tipo.id">{{tipo.descricao}}</option>
            </select>
          </form-group>
        </div>
        <div :class="isVisualizacao ? 'col-12 col-md-6' : 'col-12 col-md-6'">
          <form-group id="GrupoNotif" label="Enviar para" :text="{ required: 'Obrigatório informar o público alvo da notificação' }" :field="$v.notificacao.publico_alvo_id">
            <input type="text" class="form-control" id="grupo" v-model="descricaoGrupo" v-if="isVisualizacao"/>
            <select class="form-control" id="grupo" v-model="notificacao.publico_alvo_id" v-else  >
              <option v-for="grupo in grupos" :value="grupo.id" >{{grupo.titulo}}</option>
            </select>
          </form-group>
        </div>
        <div class="col-12">
          <form-group id="LinkNotif" label="Insira o link que o usuário será encaminhado ao clicar na notificação *" :text="{ required: 'Obrigatório informar o link' }" :field="$v.notificacao.url">
            <input type="text" class="form-control" id="url" placeholder="https://jaleko.com.br/curso/Trauma" value="" v-model="notificacao.url"/>
          </form-group>
        </div>
      </div>
      </fieldset>
      <div class="text-center">
        <div class="d-flex align-items-center justify-content-center mt-4 mb-4">
          <button class="btn btn-primary mr-3" type="button" v-if="!isVisualizacao" @click="cadastrarNotificacao">Enviar</button>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')" v-if="isVisualizacao">Fechar</a>
          <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-cadastrar')" v-else >Cancelar</a>
        </div>
      </div>
    </form>
  </b-modal>
</template>

<script>
import Swal from 'sweetalert2'
import NotificacaoAPI from '@/api/notificacao-api'
import PublicoAlvoAPI from '@/api/publico-alvo-api'
import { required } from 'vuelidate/lib/validators'
import FormGroup from '@/core/components/FormGroup'
import ResponseUtils from '@/core/util/response-utils'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'ModalCadastroNotificacao',
  components: {
    FormGroup
  },

  props: {
    notificacaoEdicao: Object,
    tipos: Array
  },

  data () {
    return {
      notificacao: {
        notificacao: '',
        descricao: '',
        tipo_notificacao_id: null,
        publico_alvo_id: null,
        ocorrencia_atual: 1,
        ocorrencia_quantidade: null,
        ocorrencia_dias_intervalo: null,
        url: ''
      },
      grupos: Array
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.$v.$reset()

      if (this.notificacaoEdicao) {
        this.notificacao = Object.assign({}, this.notificacaoEdicao)
      } else {
        this.notificacao = {
          notificacao: '',
          descricao: '',
          ocorrencia_atual: 1,
          ocorrencia_quantidade: 1,
          ocorrencia_dias_intervalo: 1,
          tipo_notificacao_id: null,
          publico_alvo_id: null,
          url: ''
        }
      }

      PublicoAlvoAPI.listar().then(data => {
        this.grupos = data
      })
    })
  },

  computed: {
    isVisualizacao: function () {
      return this.notificacaoEdicao
    },
    descricaoGrupo: function () {
      let descricao = this.notificacao.grupo ? this.notificacao.grupo.descricao : null
      return descricao
    },
    descricaoTipo: function () {
      let descricao = this.notificacao.tipo ? this.notificacao.tipo.descricao : null
      return descricao
    }
  },

  validations: {
    notificacao: {
      notificacao: { required },
      ocorrencia_quantidade: { required },
      ocorrencia_dias_intervalo: { required },
      tipo_notificacao_id: { required },
      publico_alvo_id: { },
      url: { required }
    }
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-cadastrar')
    },

    cadastrarNotificacao: function () {
      this.$v.notificacao.$touch()
      if (!this.$v.notificacao.$invalid) {
        const loader = this.$loading.show()

        NotificacaoAPI.salvar(this.notificacao).then(data => {
          loader.hide()

          Swal.fire({
            icon: 'success',
            showCloseButton: true,
            text: 'Notificacao criada com sucesso'
          }).then(() => {
            this.$bvModal.hide('modal-cadastrar')
            this.$emit('notificacaoSalva', this.notificacao)
          })
        }).catch(error => ResponseUtils.handleError(error, loader))
      }
    }
  }
}
</script>
<style>
  div.modal-conta i.glyphicon-calendar{
    font-size: inherit;
  }
</style>
